import { LocalNotifications } from '@capacitor/local-notifications'

import { isCapacitor } from 'src/utils/capacitor'

let nextId = 1

export const showLocalNotification = async (params: {
  title: string
  body: string
  extra?: Record<string, unknown>
}) => {
  if (!isCapacitor()) return
  try {
    const status = await LocalNotifications.checkPermissions()
    if (status.display !== 'granted') {
      const requested = await LocalNotifications.requestPermissions()
      if (requested.display !== 'granted') return
    }

    await LocalNotifications.schedule({
      notifications: [
        {
          id: nextId++,
          title: params.title,
          body: params.body,
          extra: params.extra,
        },
      ],
    })
  } catch (err) {
    console.warn('Local notification failed:', err)
  }
}
